/* ============================================================
   SKYNT — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky Header ───────────────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Nav Drawer ─────────────────────────────────────────── */
  const drawer   = document.querySelector('.nav-drawer');
  const openBtn  = document.querySelector('.hamburger-btn');
  const closeBtn = document.querySelector('.drawer-close');
  const overlay  = document.querySelector('.nav-drawer__overlay');

  function openDrawer()  { drawer?.classList.add('open');    document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer?.classList.remove('open'); document.body.style.overflow = ''; }

  openBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ── Scroll Reveal ──────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach((el) => observer.observe(el));
  }

  /* ── Accordion ──────────────────────────────────────────── */
  document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item   = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach((el) => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Variant Selection ──────────────────────────────────── */
  document.querySelectorAll('.variant-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('.product-variants')
        ?.querySelectorAll('.variant-btn')
        .forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  /* ── Cart Count ─────────────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent   = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  /* ── Newsletter Form ────────────────────────────────────── */
  const nlForm = document.querySelector('[data-newsletter-form]');
  if (nlForm) {
    nlForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn   = nlForm.querySelector('.newsletter__btn');
      const input = nlForm.querySelector('.newsletter__input');
      if (btn)   btn.textContent = 'Thank you ✓';
      if (input) input.value = '';
      setTimeout(() => { if (btn) btn.textContent = 'Subscribe'; }, 3000);
    });
  }

  /* ── Testimonials Drag Scroll ───────────────────────────── */
  const track = document.querySelector('.testimonials__track');
  if (track) {
    let isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown',  (e) => { isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft; track.style.cursor = 'grabbing'; });
    track.addEventListener('mouseleave', ()  => { isDown = false; track.style.cursor = ''; });
    track.addEventListener('mouseup',    ()  => { isDown = false; track.style.cursor = ''; });
    track.addEventListener('mousemove',  (e) => { if (!isDown) return; e.preventDefault(); track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.5; });
  }

})();


/* ── Predictive Search ──────────────────────────────── */
(function () {
  const searchInput = document.querySelector('#search-input');
  const resultsBox  = document.querySelector('#predictive-search');
  if (!searchInput || !resultsBox) return;

  let timer;

  searchInput.addEventListener('input', function () {
    const q = this.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { resultsBox.style.display = 'none'; return; }
    timer = setTimeout(() => fetchPredictive(q), 300);
  });

  searchInput.addEventListener('blur', () => {
    setTimeout(() => { resultsBox.style.display = 'none'; }, 200);
  });

  function fetchPredictive(q) {
   fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,tag,body&resources[options][prefix]=last')
      .then((r) => r.json())
      .then((data) => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { resultsBox.style.display = 'none'; return; }
        resultsBox.innerHTML = products.map((p) =>
          '<a href="' + p.url + '" style="display:flex;align-items:center;gap:0.75rem;padding:0.75rem 1rem;text-decoration:none;border-bottom:1px solid var(--border-light);">' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" style="width:44px;height:44px;object-fit:cover;flex-shrink:0;">' : '') +
          '<div style="flex:1;min-width:0;"><p style="font-size:14px;font-weight:500;color:var(--text-dark);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</p>' +
          '<p style="font-size:13px;color:var(--text-muted-light);">' + p.price + '</p></div></a>'
        ).join('');
        resultsBox.style.display = 'block';
      })
      .catch(() => {});
  }
})();


/* ── Product Recommendations ────────────────────────── */
(function () {
  const container = document.querySelector('#product-recommendations');
  if (!container) return;
  const url = container.dataset.url;
  if (!url) return;

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      const doc      = new DOMParser().parseFromString(html, 'text/html');
      const products = doc.querySelectorAll('.product-card');
      if (!products.length) { container.closest('div') && container.closest('div').remove(); return; }
      const grid = document.createElement('div');
      grid.style.cssText = 'display:grid;grid-template-columns:repeat(4,1fr);gap:1.5rem;';
      products.forEach((p) => grid.appendChild(p));
      container.appendChild(grid);
    })
    .catch(() => {});
})();


/* ── Cart Notification Toast ────────────────────────── */
function showCartNotification() {
  const el = document.querySelector('#cart-notification');
  if (!el) return;
  el.style.transform = 'translateY(0)';
  el.style.opacity   = '1';
  setTimeout(() => {
    el.style.transform = 'translateY(200%)';
    el.style.opacity   = '0';
  }, 2500);
}


/* ── Gallery Thumbnails ─────────────────────────────── */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.pdp-thumb');
  if (!btn) return;

  const mainImg = document.getElementById('pdp-main-img');
  if (!mainImg) return;

  const src = btn.getAttribute('data-src');
  const alt = btn.getAttribute('data-alt');

  if (src) {
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
  }
  if (alt) mainImg.alt = alt;

  document.querySelectorAll('.pdp-thumb').forEach(function (b) {
    const active = (b === btn);
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  const thumbArr = Array.from(document.querySelectorAll('.pdp-thumb'));
  const idx      = thumbArr.indexOf(btn);
  document.querySelectorAll('.pdp-dot').forEach(function (d, j) {
    d.classList.toggle('is-active', j === idx);
  });
});


/* ── Product Page Quantity Buttons ──────────────────── */
document.addEventListener('click', function (e) {
  if (document.querySelector('.cart-page')) return;

  const dec = e.target.closest('.pdp-qty-btn.qty-decrease');
  const inc = e.target.closest('.pdp-qty-btn.qty-increase');
  if (!dec && !inc) return;

  const wrap  = (dec || inc).closest('.pdp-qty');
  if (!wrap) return;
  const input = wrap.querySelector('.pdp-qty-input');
  if (!input) return;

  let val = parseInt(input.value) || 1;
  if (dec) val = Math.max(1, val - 1);
  if (inc) val = val + 1;
  input.value = val;
});

/* ── Cart Page qty + remove ─────────────────────────── */
(function(){
  var cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;

  cartPage.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;

    var key = btn.getAttribute('data-cart-change');
    var qty = parseInt(btn.getAttribute('data-qty'));
    if (!key) return;

    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      window.location.reload();
    })
    .catch(function(){
      window.location.reload();
    });
  });
})();